import { useScreen } from '../../../../../hooks'
import { AttachedRequests } from '../AttachedRequests'
import {
  CopiedToTagList,
  getPreparedCopiedToTagItems,
} from '../CopiedToTagList'

import * as styles from './EmailMessageTags.module.css'

function EmailMessageTags({ data, onClickRemoveCopiedEntity }) {
  const {
    archive_copy_entities: archiveCopyEntities,
    linked_requests: linkedRequests,
  } = data

  const { containerRef } = useScreen()

  const preparedCopiedToList = getPreparedCopiedToTagItems(archiveCopyEntities)

  const hasTags = linkedRequests.length > 0 || preparedCopiedToList.length > 0

  return hasTags ? (
    <div className={styles.EmailMessageTags}>
      {linkedRequests.length > 0 ? (
        <AttachedRequests items={linkedRequests} moreProps={{ containerRef }} />
      ) : null}

      {preparedCopiedToList.length > 0 ? (
        <CopiedToTagList
          items={preparedCopiedToList}
          moreProps={{ containerRef }}
          onClickRemoveCopiedEntity={onClickRemoveCopiedEntity}
        />
      ) : null}
    </div>
  ) : null
}

export default EmailMessageTags
